// Deterministic number formatting for SSG. Intl output depends on the runtime's ICU data: Node
// has full ICU ("165 000") but Chromium ships no `uz` locale and falls back to en ("165,000"),
// so every Intl-formatted number on the uz pages broke hydration (React #418/#425 → full client
// re-render). uz and ru both group thousands with a no-break space and use a decimal comma.

const NBSP = " ";

/** Groups thousands with NBSP and uses a decimal comma: 4200000 → "4 200 000", (4.25, 1) → "4,3". */
export function groupDigits(n: number, decimals = 0): string {
  const [int, frac] = Math.abs(n).toFixed(decimals).split(".");
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
  return (n < 0 ? "-" : "") + grouped + (frac ? `,${frac}` : "");
}

/** Like groupDigits, but drops trailing fraction zeros: (165000, 2) → "165 000", (4.5, 2) → "4,5". */
export function groupDigitsTrim(n: number, maxDecimals: number): string {
  const s = groupDigits(n, maxDecimals);
  return s.includes(",") ? s.replace(/0+$/, "").replace(/,$/, "") : s;
}
